<template>
	<div>
		<base-header class="pb-6">
			<b-row align-v="center" class="py-3">
				<b-col cols="6">
					<p class="text-muted">My Account</p>
					<h2 class="listing-title d-inline-block mb-0">SME Reports</h2>
				</b-col>
			</b-row>
		</base-header>
		<b-container fluid class="mt--6">
			<b-card no-body class="px-3 pb-3">
                <CtosReport @refresh="refreshList" />
			</b-card>
			<b-card no-body class="px-3 pb-3">
                <PurchaseHistory ref="purchaseHistory" />
			</b-card>
		</b-container>
	</div>
</template>
<script>
import { Card, Button, Tag, Select, Option, Input, DatePicker, Table, TableColumn } from 'element-ui'
import CtosReport from '@/views/CreditReports/SMEReports/CTOSReport/CTOSReport.vue'
import PurchaseHistory from '@/views/CreditReports/SMEReports/PurchaseHistory/PurchaseHistoryListings.vue'

export default {
    components: {
        CtosReport,
        PurchaseHistory,
        [Card.name]: Card,
        [Button.name]: Button,
        [Tag.name]: Tag,
        [Select.name]: Select,
        [Option.name]: Option,
        [Input.name]: Input,
        [DatePicker.name]: DatePicker,
        [Table.name]: Table,
        [TableColumn.name]: TableColumn,
    },
    data() {
        return {
            //
        }
    },
    methods: {
        refreshList() {
            this.$refs.purchaseHistory.refreshList()
        }
    }
}
</script>